import axios from 'axios';

// API Configuration
const API_BASE_URL = 'https://artmltapi.kssvnr.com/api';

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    if (status === 401) {
      const requestUrl = error.config?.url || '';
      const isAuthRequest =
        requestUrl.includes('/auth/login') ||
        requestUrl.includes('/auth/forgot-password') ||
        requestUrl.includes('/auth/reset-password');
      const isOnLoginPage = typeof window !== 'undefined' && window.location?.pathname === '/login';
      const hasToken = !!localStorage.getItem('token');

      // Only force redirect when a logged-in session becomes unauthorized.
      // Do NOT redirect for login/forgot/reset auth requests or when no token exists.
      if (hasToken && !isAuthRequest && !isOnLoginPage) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
        return; // stop further handling after redirect
      }
    }
    return Promise.reject(error);
  }
);

export default api;
